module.exports = __webpack_public_path__ + "static/media/Screenshot_1.23d3b576.png";